import {
  AUTH_CONFIRM_TOKEN_CHECKED,
  AUTH_LOGIN_PROGRESS,
  AUTH_LOGIN_FAILED,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESTORE,
  AUTH_UPDATE_PASSWORD_TOKEN
} from '../actions/auth';
import { MANAGER_ROLE_PRODUCT } from '../api/manager';

const AUTH_TOKEN_KEY = 'auth';

const initialState = {
  loadingLogin: false,
  token: sessionStorage.getItem(AUTH_TOKEN_KEY),
  user: null,
  rbac: {},
  updateToken: {}
};

const EVENT_MANAGER_RBAC = {
  manageManagers: false,
  manageSettings: false,
  manageClubs: true
};

const PRODUCT_MANAGER_RBAC = Object.assign({}, EVENT_MANAGER_RBAC, {
  manageSettings: true,
  manageManagers: true
});

export default function(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN_PROGRESS:
      return Object.assign({}, state, {
        loadingLogin: true,
        message: undefined
      });

    case AUTH_LOGIN_SUCCESS:
      let { token } = action;
      return Object.assign({}, state, {
        loadingLogin: false,
        token
      });

    case AUTH_LOGIN_FAILED:
      let {message} = action;
      return Object.assign({}, state, {
        loadingLogin: false,
        message
      });

    case AUTH_LOGOUT:
      return Object.assign({}, initialState, {token: null});

    case AUTH_RESTORE:
      return Object.assign({}, state, {
        user: action.user,
        rbac: action.user.role === MANAGER_ROLE_PRODUCT ? PRODUCT_MANAGER_RBAC : EVENT_MANAGER_RBAC

      });

    case AUTH_UPDATE_PASSWORD_TOKEN:
      return updatePasswordStatus(state, action);

    case AUTH_CONFIRM_TOKEN_CHECKED:
      return Object.assign({}, state, {confirmTokenValid: action.confirmTokenValid});

    default:
      return state;
  }
}

function updatePasswordStatus(state, action) {
  let {token, status} = action;
  return Object.assign({}, state, {
    updateToken: {
      token,
      status
    }
  });
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js